import React, { useState, useEffect } from 'react';
import './FinanceAccounts.css';
import FinanceHero from '../../components/FinanceHero/FinanceHero.jsx'; // Optional hero banner
import publicAxios from '../../utils/axios/publicAxios';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Circles } from 'react-loader-spinner';
import IMAGEALT from '../../assets/images/igboezenorthlga.png';

const FinanceAccounts = () => {

  const [posts, setPosts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchMode, setSearchMode] = useState(false);

  const stripHtmlAndTruncate = (html, maxLength = 50) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };


  const fetchPosts = async (page = 1) => {
    try {
      setLoading(true);
      const response = await publicAxios.get(`/public/posts-by-category/finance?page=${page}`);
      setPosts(response.data.posts);
      setTotalPages(response.data.totalPages);
      setCurrentPage(page);
    } catch (error) {
      console.error('Error fetching posts', error);
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchSearchedPosts = async (page = 1) => {
    try {
      setLoading(true);
      const response = await publicAxios.get(`/public/search-posts-by-category/finance?query=${searchTerm.trim()}&page=${page}`);
      setPosts(response.data.posts);
      setTotalPages(response.data.totalPages);
      setCurrentPage(page);
    } catch (error) {
      console.error('Error searching posts', error);
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  const handleSearch = () => {
    if (!searchTerm.trim()) {
      setSearchMode(false);
      fetchPosts(1);
    } else {
      setSearchMode(true);
      fetchSearchedPosts(1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      searchMode ? fetchSearchedPosts(nextPage) : fetchPosts(nextPage);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      searchMode ? fetchSearchedPosts(prevPage) : fetchPosts(prevPage);
    }
  };

  return (
    <div className="finance-accounts">
      <FinanceHero />

      <section className="finance-intro">
        <div className="finance-intro-content">
          <div className="finance-text">
            <h2>Ensuring Financial Integrity</h2>
            <p>
              The Department of Finance & Accounts is the financial engine room of Igbo-Eze North Local Government Council.
              It oversees budgeting, revenue generation, financial compliance, and reporting to ensure transparent and accountable governance.
            </p>
          </div>
        </div>
      </section>

      <div className="posts-wrapper">
        <div className="posts-header">
          <div className='posts-search-input'>
            <input
              type="text"
              placeholder="Search posts..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button className='posts-search-btn' onClick={handleSearch}>Search</button>
          </div>
        </div>
        <div className="posts-list">
          {loading ? (
            <div style={{ display: 'flex', flexDirection: 'column', columnGap: '10px', alignItems: 'center', justifyContent: 'center', height: '300px', color: 'gray' }}>
              <Circles height="50" width="50" color="#008751" ariaLabel="loading" /> <h3>Loading Posts...</h3>
            </div>
          ) : posts.length ?
            posts.map((a, index) => (
              <div className="posts-card" key={a._id || index}>
                <Link className='posts-read-more' to={`/post/${a.slug}`}>

                  <div className="post-image">
                    {a.imageUrl ?
                      <img src={a.imageUrl} alt={a.title} loading='lazy' /> :
                      <div>
                        <img src={IMAGEALT} alt={a.title} className="posts-image" loading='lazy' />
                      </div>}
                  </div>
                  <div className="posts-content">
                    <p className="posts-date">{moment(a.createdAt).format('MMMM DD, YYYY')}</p>
                    <h3>{stripHtmlAndTruncate(a.title, 100)}</h3>

                    {/* <p className="posts-description">
                                        {stripHtmlAndTruncate(a.content, 150)}
                                      </p> */}
                  </div>

                </Link>
              </div>
            ))
            : (
              <div style={{ alignSelf: 'center', width: '90%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><p>No posts found.</p></div>
            )}
        </div>
        {posts.length > 10 &&
          <div className="posts-pagination-controls">
            <button onClick={handlePreviousPage} disabled={currentPage === 1}>Previous</button>
            <span>Page {currentPage} of {totalPages}</span>
            <button onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
          </div>
        }
      </div>
    </div>
  );
};

export default FinanceAccounts;